<div [formGroup]="form">
  <div class="flex flex-column gap-4 align-items-center">
    <div class="flex flex-column gap-2 w-full">
      <label for="faultCode" class="font-semibold"> {{"ignored_fault_list.fault_code" | translate}}* </label>
      <input id="fault_code" pInputText formControlName="code" appTrimInput />
    </div>
    <div class="flex flex-column gap-2 w-full">
      <label for="faultDescription" class="font-semibold">
        {{"ignored_fault_list.fault_description" | translate}}
      </label>
      <textarea id="faultDescription" pInputTextarea formControlName="description" appTrimInput></textarea>
    </div>
  </div>
  <div class="flex justify-content-end gap-2 dialogBtnGroup mt-4">
    <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
    <app-button buttonText="common.save" (click)="save()" [disabled]="!form.valid"></app-button>
  </div>
</div>
